/**
 * Generated by orval v8.16.0 🍺
 * Do not edit manually.
 * FinPath API
 * Backend API programu FinPath (panel admina + aplikacja mobilna).
 * OpenAPI spec version: 0.1.0
 */

/**
 * * `daily` - Dzienny
 * * `weekly` - Tygodniowy
 * * `monthly` - Miesięczny
 * * `weekend` - Weekendowy
 * * `concept` - Pojęciowy
 */
export type QuizCycleEnum = typeof QuizCycleEnum[keyof typeof QuizCycleEnum];


export const QuizCycleEnum = {
  daily: 'daily',
  weekly: 'weekly',
  monthly: 'monthly',
  weekend: 'weekend',
  concept: 'concept',
} as const;
